<template>
    <PopupRouterView :showLeftIcon="true" label="Part Price Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="partprice"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="partPriceInput">


        <b-card header="Part Price" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Part Price Id" :model="model.id" />
						<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part" id="fieldset-part" size="sm" :model.sync="model.partId" :isRequired="true" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts"   :isSelectMethodExists="true" @onSelectMethod="setSelectedPart" :isEditable="isShowInput" />
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(model.part != null) ? model.part.partName : null"  />
						<app-label label-cols-lg="12" size="sm" label="Part Classification" :model="(model.part != null) ? (model.part.partClassification != null) ? model.part.partClassification.code : null : null"  />
						<app-label label-cols-lg="12" size="sm" label="Customer" :model="getCustomerCodeName()"  />
						<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Vendor" id="fieldset-vendor-id" size="sm" :model.sync="model.vendorIdId"  :selected="model.vendorId != null ? model.vendorId.code : ''" :isSelectMethodExists="true" @onSelectMethod="setSelectedVendorId"  :isEditable="isShowInput"/>
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-price-process" label-cols-lg="12" label="Price Process" label-for="input-price-process" size="sm" :thousandSeparator="true" :model.sync="model.priceProcess"  :isRequired="true" :state="validateState('priceProcess')" :errorMessage="getErrorMessage(errorMessage.priceProcess, 'priceProcess')" :isEditable="isShowInput" />
						<app-input-textbox id="fieldset-price-product" label-cols-lg="12" label="Price" label-for="input-price-product" size="sm" :thousandSeparator="true" :model.sync="model.priceProduct"  :isRequired="true" :state="validateState('priceProduct')" :errorMessage="getErrorMessage(errorMessage.priceProduct, 'priceProduct')" />
						<app-input-datepicker id="fieldset-start-date" label-cols-lg="12"  label="Start Date" size="sm" :min="minStartDate" :model.sync="model.startDate" :isRequired="true" :state="validateState('startDate')" :errorMessage="getErrorMessage(errorMessage.startDate, 'startDate')"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" :isEditable="isShowInput" />
						<app-input-datepicker id="fieldset-end-date" label-cols-lg="12"  label="End Date" size="sm" :model.sync="model.endDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" :isEditable="false" :notUseDefaultValue="true"/>
				</b-col>

            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PartPrice from '@/models/PartPrice/PartPrice';
import PartPriceList from '@/models/PartPrice/PartPriceList';
import PartPriceFilter from '@/filters/PartPrice/PartPriceFilter';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Part from '@/models/Part/Part';
import PartDetail from '@/models/Part/PartDetail';
import PartFilter from '@/filters/Part/PartFilter';
import PartDetailFilter from '@/filters/Part/PartDetailFilter';
import AppLabel from '@/components/AppLabel';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputDatepicker,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextbox,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			partId: {required},
			priceProcess: {required},
			priceProduct: {required},
			startDate: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				partId: { required : "Part is Required."},
				priceProcess: { required : "Price Process is Required."},
				priceProduct: { required : "Price Product is Required."},
				startDate: { required : "Start Date is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterPartPrice : null,
			currentPartPricePage : 1,
			partPricePageSize: 10,
			sortByPartPrice: '',
			sortDescPartPrice: '',
			parts: [],
			partDetails : [],
			isPartComboLoading: false,
			vendors: [],
			vendorIds: [],
			isVendorIdComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isPartComboLoading: false,
			minStartDate: new Date(),
			isVendorComboLoading: false,
		}
	},
	methods : {
		getCustomerCodeName() {
			if(this.model != null && this.model.part != null && this.model.part.customer != null) {
				return this.model.part.customerCode + " - " + this.model.part.customer.name
			}
			return "";
		},
		getPartPrice : async function(id) {
			this.isBusy = true;
			PartPrice.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				if(this.model.partId != null) {
					promises.push(
						this.getPart(this.model.partId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPartPrice = true;
			this.filterPartPrice.id = this.modelId;
			PartPrice.downloadDataDetail(this, this.filterPartPrice).then(result => {
				this.isDownloadPartPrice = false;
			}).catch(error => { this.isDownloadPartPrice = false; })
		},
		getPartPrices : async function(input) {
			let filter = new PartPriceFilter();
			if (input != undefined) {
				filter.Part = input;
			}
			this.isPartPriceComboLoading = true;
			PartPrice.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partPrices = result.data
				}
				this.isPartPriceComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPart(item) {
			this.vendors = [];
			this.partDetails = [];
			this.model.vendorIdId = null;
			this.model.vendorId = null;

			if(item == undefined || item == null) {
				this.model.partId = null;
				this.model.part = null;
			} else {
				this.model.partId = item.id;
				this.model.part = item;
				this.getPartDetail(item.id);
			}
			this.$forceUpdate();
			this.updateData();
		},
		getPartDetail(partId) {
			let filter = new PartDetailFilter();
			filter.partId = partId;
			PartDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partDetails = result.data
					this.getVendors();
				}
			})
			.catch(error => {});
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			
			if (this.partDetails.length > 0) {
				let supplierCodes = [];

				this.partDetails.forEach(element => {
					if (element != null && element.supplierCode != null && element.supplierCode.code) {
						supplierCodes.push(element.supplierCode.code);
					}
				});
				if (input != undefined) {
					supplierCodes.push(input);
				}
				
				filter.code = supplierCodes.join(',');

				Vendor.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.vendors = result.data
					}
				})
				.catch(error => {});
			}
		},
		setSelectedVendorId(item) {
			if(item == undefined || item == null) {
				this.model.vendorIdId = null;
				this.model.vendorId = null;
			} else {
				this.model.vendorIdId = item.id;
				this.model.vendorId = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getPart : async function(id) {
			Part.getData(this, id).then(result => {
				this.model.part = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.partPriceInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;
				let promises = Array();
				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						PartPrice.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'partpriceindex' });
							}
							this.isBusy = false;
							this.$router.back();
						}).catch(error => { this.isBusy = false; });
					} else {
						PartPrice.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'partpriceindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PartPrice.updateData(this, model, id)
					.catch((error) => {
						this.getPartPrice(id);
					});
				}
			});
		},
		onHidden() {
			this.getPartPrices();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterPartPrice = new PartPriceFilter();
		//this.getParts();
		this.getVendors();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPartPrice(id);
			} else {
				this.modelId = id;
				this.getPartPrice(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isShowInput: {
			get: function() {
				let id = this.modelId;
				if (id != '' && id != null && id != undefined) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
